/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInvoicesRequestPageSize
 */
export interface GetInvoicesRequestPageSize {
}

/**
 * Check if a given object implements the GetInvoicesRequestPageSize interface.
 */
export function instanceOfGetInvoicesRequestPageSize(value: object): value is GetInvoicesRequestPageSize {
    return true;
}

export function GetInvoicesRequestPageSizeFromJSON(json: any): GetInvoicesRequestPageSize {
    return GetInvoicesRequestPageSizeFromJSONTyped(json, false);
}

export function GetInvoicesRequestPageSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicesRequestPageSize {
    return json;
}

export function GetInvoicesRequestPageSizeToJSON(json: any): GetInvoicesRequestPageSize {
    return GetInvoicesRequestPageSizeToJSONTyped(json, false);
}

export function GetInvoicesRequestPageSizeToJSONTyped(value?: GetInvoicesRequestPageSize | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

